/* eslint-disable max-lines-per-function */
/**
 * VISALL 漏斗图组件
 * @description 用于展示数据项依次递减或递增的流程数据，支持水平和垂直方向展示
 */
import {
  type Layer,
  type StandardChartLayerSpec,
  defineStandardChartLayer,
  type StandardChartLayerRenderResult
} from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';

// 基础信息配置
const baseInfo: Layer['visInfo'] = {
  id: 'funnel',
  name_en: 'Funnel',
  // name_zh: '漏斗图',
  types_en: ['funnel'],
  purpose_en: ['comparison', 'proportion'],
  // purpose_zh: ['对比', '占比'],
  standers: 'f10',
  parameters: {}
};

// 图表配置
const layerConfig = {
  visInfo: {
    ...baseInfo,
    rules: {
      x: (amount: number) => amount > 1,
      y: (amount: number) => amount > 1
    },
    parameters: {
      x: {
        itemType: [DEFINE.STR],
        category: DEFINE.SINGLE
      },
      y: {
        itemType: [DEFINE.NUMBER],
        category: DEFINE.SINGLE
      }
    }
  }
};

// 类型定义
interface IFunnelDataItem {
  name: string;
  value: number;
}

export interface IFunnelSpec extends StandardChartLayerSpec {
  encoding: {
    x: string;
    y: string;
  };
}

/**
 * 漏斗图组件
 */
export const layer = defineStandardChartLayer<IFunnelSpec>({
  type: baseInfo.id,
  isIndependentLayer: false,
  visInfo: layerConfig.visInfo,
  render(api, spec) {
    const { data: dataArray } = api;
    const {
      dataIndex = 0,
      encoding: { x, y }
    } = spec;

    // 数据处理
    const data = dataArray[dataIndex];

    // 格式化数据
    const seriesData: IFunnelDataItem[] = data.values.map(item => ({
      name: String(item[x]),
      value: Number(item[y])
    }));

    // 配置项 - 只保留必要配置
    const options: Partial<StandardChartLayerRenderResult> = {
      // 漏斗图不需要坐标轴
      xAxis: [] as StandardChartLayerRenderResult['xAxis'],
      yAxis: [] as StandardChartLayerRenderResult['yAxis'],

      // 系列配置
      series: [
        {
          type: 'funnel',
          name: y,
          __encodeField: y,
          data: seriesData
        }
      ]
    };

    return options;
  }
});
